import { useForecastingChannels } from "~/hooks/useChannels"
import { Tooltip } from "react-tooltip"

interface ChannelsSummaryProps {
  channelIds: string[]
}

export default function ChannelsSummary({ channelIds }: ChannelsSummaryProps) {
  const { data: allForecastingChannels } = useForecastingChannels()

  if (allForecastingChannels === undefined) {
    return null
  }

  if (allForecastingChannels?.every((c) => channelIds.includes(c.id))) {
    return <div>All</div>
  }

  const filteredChannels = allForecastingChannels.filter((c) => channelIds.includes(c.id))
  const tooltipId = `channels-${channelIds.join("-")}`
  const tooltipContent = filteredChannels
    .map((c) => c.name)
    .join(", ")
    .slice(0, 30)

  return (
    <>
      <div data-tooltip-id={tooltipId}>
        {filteredChannels.map((c) => (
          <div key={c.id}>{c.name}</div>
        ))}
      </div>
      <Tooltip id={tooltipId}>{tooltipContent}</Tooltip>
    </>
  )
}
